export const FREE_SPIN_AWARDS = Object.freeze({ 3: 10, 4: 11, 5: 12 } as const);

export type FreeSpinAward = (typeof FREE_SPIN_AWARDS)[keyof typeof FREE_SPIN_AWARDS];

export function getFreeSpinAward(scatterCount: number): FreeSpinAward | 0 {
  if (!Number.isSafeInteger(scatterCount) || scatterCount < 0) {
    throw new RangeError('Die Scatter-Anzahl muss eine nichtnegative sichere Ganzzahl sein.');
  }
  if (scatterCount < 3) return 0;
  if (scatterCount === 3) return FREE_SPIN_AWARDS[3];
  if (scatterCount === 4) return FREE_SPIN_AWARDS[4];
  return FREE_SPIN_AWARDS[5];
}

